if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.variantInfo = this.querySelector('.quantity-popover-container');
        this.eventMouseEnterHappened = false;

        // popover="manual" keeps open/close JS-owned; positionPanel() replaces the lost positioned-ancestor.
        if (this.popoverInfo) {
          this.popoverInfo.removeAttribute('hidden');
          this.popoverInfo.setAttribute('popover', 'manual');
          this.onReposition = this.positionPanel.bind(this);
        }

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        this.addEventListener('keyup', this.onKeyUp.bind(this));

        if (this.popoverInfo && this.infoButtonDesktop && this.mql.matches) {
          this.popoverInfo.addEventListener('mouseenter', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonMobile.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.variantInfo.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.variantInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      // Manual positioning instead of CSS Anchor Positioning — cross-browser support was too
      // limited at the time this was written. Revisit migrating to it later.
      positionPanel() {
        const containerRect = this.getBoundingClientRect();
        this.popoverInfo.style.top = `${containerRect.bottom}px`;
        this.popoverInfo.style.left = `${containerRect.left}px`;
        this.popoverInfo.style.width = `${containerRect.width}px`;
      }

      openPopover() {
        this.positionPanel();
        this.popoverInfo.showPopover();
        window.addEventListener('scroll', this.onReposition, true);
      }

      hidePopoverPanel() {
        if (this.popoverInfo.matches(':popover-open')) {
          this.popoverInfo.hidePopover();
        }
        window.removeEventListener('scroll', this.onReposition, true);
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = event.currentTarget === this.variantInfo ? this.infoButtonDesktop : event.currentTarget;
        const willOpen = !this.popoverInfo.matches(':popover-open');

        button.setAttribute('aria-expanded', willOpen.toString());
        this.openButton = willOpen ? button : null;

        if (willOpen) {
          this.openPopover();
        } else {
          this.hidePopoverPanel();
        }

        button.classList.toggle('quantity-popover__info-button--open', willOpen);

        if (willOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      onKeyUp(event) {
        if (event.code !== 'Escape') return;

        const button = this.openButton;
        if (!button || button.getAttribute('aria-expanded') !== 'true') return;

        button.setAttribute('aria-expanded', 'false');
        button.classList.remove('quantity-popover__info-button--open');
        this.hidePopoverPanel();
        this.openButton = null;
        this.eventMouseEnterHappened = false;
        button.focus();
      }

      closePopover(event) {
        event.preventDefault();
        const isChild = this.variantInfo.contains(event.relatedTarget);

        this.eventMouseEnterHappened = false;

        const button = this.openButton;
        if (!button) return;

        if (!event.relatedTarget || !isChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.hidePopoverPanel();
          this.openButton = null;
        }
      }
    }
  );
}
